// extracted by mini-css-extract-plugin
module.exports = {"toBeCenter":"VideoPlayer_toBeCenter__PBK5C","videoPlayer":"VideoPlayer_videoPlayer__4KEK6"};